/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Vacatures',
    titleMeta: 'Vacatures | CamDiab',
    descriptionMeta: 'Ontdek carrièremogelijkheden bij CamDiab. Sluit u aan bij ons team voor betere diabeteszorg.',
    keywords: 'CamDiab vacatures, werk, banen, diabetes',
    localeMeta: 'nl_nl',

    bannerTitle: 'Vacatures',
    bannerSubtitle: 'Wilt u bij ons team komen?',
    heroNote: 'Alle vacatures worden in het Engels gepubliceerd.',

    introBody:
        'Zoekt u een nieuwe uitdaging en wilt u betekenisvolle verandering helpen vormgeven? We horen graag van u. We investeren in onze mensen — het kloppend hart van CamDiab. Onze arbeidsvoorwaarden zijn bedoeld om het beste uit iedereen te halen, waaronder:',

    benefitsTitle: '',
    benefits: [
        'Ruim pensioenbijdrage werkgever',
        'Aanvullende ziektekostenverzekering',
        'Levensverzekering',
        'Jaarlijkse discretionaire bonus',
        '29 vakantiedagen plus 8 feestdagen',
        'Mogelijkheid om te werken aan baanbrekende technologie die diabeteszorg en patiëntuitkomsten kan transformeren',
        'Samenwerkende en dynamische werkomgeving',
        'Concurrerend salaris en arbeidsvoorwaarden, inclusief professionele ontwikkeling en doorgroeimogelijkheden',
    ],

    outroHtml:
        'Bent u gepassioneerd over echte impact in de praktijk? We horen graag van u:<a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    vacancies: [],

    emptyVacancyTitle: 'Geen openstaande vacatures',
    emptyVacancyBody:
        'We zoeken misschien op dit moment niemand, maar CamDiab groeit, en we horen graag van mensen die net zo gepassioneerd zijn over een beter leven met diabetes. Kijk later opnieuw.',

    applyLabel: 'Solliciteer nu',
};
